<template>
  <div class="home">

   <div class="home-ct">
	   <div class="product">
		   <div class="product-st">
			   <div class="pic">
				  <div class="l1">
				
					 <div class="block">
						 <el-carousel trigger="click" @change="carou" ref="carousel" :initial-index='ride' height="300px" autoplay=false>
					       <el-carousel-item v-for="item in news.images" :key="item">
							   <img :src="item" />
					   
					       </el-carousel-item>
					     </el-carousel>
					   </div>
				  </div>
				  <div class="l2">
					  <ul>
						<li :class="{'item-acticve':ride == index}"  @click="nood(index)" v-for="(item,index) in news.images"><img :src="item"/></li>
					  </ul>
				  </div>
			   </div>
			    <div class="txt">
					<h2>{{news.title}}</h2>
					<div class="l3"><img src="../../assets/stock.png"></div>
					<div class="l4">
						$ {{news.price_sale}}
						<span>Tax included</span>
					</div>
					<div class="l5">
						 <el-input-number size="mini"  v-model="num" @change="handleChange" :min="1" :max="10" ></el-input-number>
						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
					</div>
					<div class="wishlist">
						<div class="co1">
							<img v-if="news.if_shoucang==0" @click="collect(0)" src="../../assets/like.png" />
							<img v-else @click="collect(1)" src="../../assets/likes.png" />
							Add to wishlist
						</div>
						<div class="co2">
							
							Share：
							<a href="https://www.facebook.com/sharer.php?u=http://localhost:8080/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
								
							<a href="http://twitter.com/share?text=FuelMe&url=http://localhost:8080/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
<a href="http://service.weibo.com/share/share.php?url=http://localhost:8080/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>



							
						</div>
					
					</div>
				</div>
		   </div>
		   <div class="product-bt">
			 <div class="tit">
				 DESCRIPTION
			 </div>
			 <div class="con" v-html="news.content">
				<!-- {{news.content}} -->
			 </div>
		   </div>
		   
		
		   
		  
	   </div>
	   <div class="cart" v-if="cart">
		<div class="cart-tit">
			<h4>SHOPPING CART</h4>
			<img src="../../assets/arr.png" @click="cart=false" />
					</div>
					<div class="cart-con">
						<ul>
							<li v-for="item in roll">
								<div class="lt">
								<div class="pic">
									<img :src="item.image" />
								</div>
								<div class="txt">
									<p>{{item.title}}</p><p>{{item.num}}×$ {{item.price_sale}}</p>
								</div>
								</div>
								<div class="clo" @click="bit(item)">
									<img src="../../assets/arr.png" />
								</div>
							</li>
						
					</ul>
					</div>
					
					<div class="cart-bot">
						<div class="l1">
							<h4>SUBTOTAL:</h4>
							<h4>$ {{price}}</h4>
						</div>
						<div class="l2">
							<router-link to="/product/cart"><div class="h-button cart-but">VIEW CART</div></router-link>
							<router-link to="/product/order"><div class="h-button cart-but">CHECKOUT</div></router-link>
						</div>
					</div>
		   
	   </div>
   </div>
    </div>
</template>
<script>


export default {

  data() {
    return {
		
		id:'',
	
		ride:0,
		num: 1,
		info:'',
		news:[],
		notice:[],
		cart:false,
		roll:'',
		price:0
		
    
    };
  },  mounted() {
	  
	  this.id = this.$route.query.id;
	
		this.sandMate();
		this.sandCase();
		this.sandCart();
		},methods: {
			
			carou(e){
				this.ride=e
			},
			nood(index){
				this.$refs.carousel.setActiveItem(index)
			},
		
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_detail",
				  data: {inventoryId:this.id},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						let arr=[]
						this.news=data.data;
						this.news.images.forEach((item, index) => {
							if (index<4) {
								arr.push(item)
							}
						})
						this.news.images=arr
					}
				 
				});
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},collect(it){
			
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:it},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
									this.sandMate();
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
						})
						
					}
				 
				});
			},sandYart(){
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.news.inventoryId,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						  this.cart=true;
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success("删除成功");
						
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			}
		}
};
</script>
<style lang="scss" scoped>
	.h-button{
		text-align: center;
		cursor: pointer;	
		padding: 0 50px;
		height: 50px;
		line-height: 50px;
		background: #000;
		color: #FFFFFF;
	}
	.h-button:hover{
		background-color: #333333;
	}
	.cart{
		position: fixed;
		top: 0;
		right: 0;
		background: #FFFFFF;
		width: 354px;
		border: 1px solid #eeeeee;
		.cart-tit{
			height:70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border-bottom: 1px solid #eeeeee;
			img{
				width: 11px;
				height: 10px;
			}
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-con{
			margin-bottom: 100px;
			li{
				padding: 20px;
				display: flex;
				border-bottom: 1px solid #eeeeee;
				justify-content: space-between;
				.pic{
					width: 115px;
					height: 77px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 10px;
					
				}
				.lt{
					display: flex;
				}
				
				
			}
		}
		.cart-bot{
		
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				justify-content: space-between;
			}
		}
	}
	.el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
	
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
.product{
	.product-st{
		border-bottom: 1px solid #dedede;
		display: flex;
		padding: 40px 0;
		.item-acticve{
			background: #333333;
		}
		.pic{
			width: 613px;
			.l1{
				img{
					width: 613px;
					height: 410px;
				}
				margin-bottom: 10px;
			}
			.l2{
				
				ul{
					li{
						width: 140px;
						height: 98px;
						float: left;
						margin-right: 9px;
						padding: 3px;
						img{
							width: 140px;
							height: 98px;
						}
					}
					li:last-child
					{ 
					margin-right: 0;
					}

					
				}
				
			}
		}
		.txt{
			padding: 20px 40px;
			.l3{
				margin: 20px 0;
				img{
					width: 141px;
					height: 36px;
					
				}
			}
			.l4{
				color: #2D2A2A;
				font-size: 24px;
				span{
					color: #7C7C7C;
					font-size: 20px;
					margin-left:10px;
				
				}
			}
			.l5{
				display: flex;
				margin-top: 20px;
				.cart-but{
					width: 131px;
					height:38px;
					line-height: 38px;
					background-color: #FB2C00;
					color: #FFFFFF;
					text-align: center;
					margin-left: 20px;
				}
			}
			.wishlist{
				border-top: 1px solid #dedede;
				margin-top: 100px;
				padding-top: 30px;
				color: #2D2A2A;
				font-weight: bolder;
				img{
					height: 20px;
					margin-right: 10px;
				}
				.co1{
					display: flex;
					margin-bottom: 20px;
				}
				.co2{
					display: flex;
				}
				
			}
		}
	}
	.product-bt{
		
		margin-top:20px;
		.tit{
			font-size: 22px;
			color: #2D2A2A;
			background: url(../../assets/bot1.png) no-repeat bottom left;
			padding-bottom: 20px;
		}
		.con{
	
			margin: 20px 0;
	
			
		}
		
	}
}
</style>